import { render } from "./smeta.vue?vue&type=template&id=8a60e85e&scoped=true"
import script from "./smeta.vue?vue&type=script&lang=js"
export * from "./smeta.vue?vue&type=script&lang=js"

import "./smeta.vue?vue&type=style&index=0&id=8a60e85e&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a60e85e"]])

export default __exports__